import { column } from '../interface/index'

// 任务总览 / 未分配资源
export const unassignedTaskColumns: column[] = [
  {
    title: '资源来源',
    dataIndex: 'business_type',
    width: '25%'
  },
  {
    title: '学科',
    dataIndex: 'subject',
    width: '25%'
  },
  {
    title: '分类',
    dataIndex: 'category_name',
    width: '25%'
  },
  {
    title: '待分配资源',
    dataIndex: 'count',
    width: '25%',
    scopedSlots: { customRender: 'count' }
  }
]

// 任务总览 / 处理中任务
export const processTaskColumns: column[] = [
  {
    title: '资源来源',
    dataIndex: 'business_type'
  },
  {
    title: '学科',
    dataIndex: 'subject_id'
  },
  {
    title: '分类',
    dataIndex: 'category_name'
  },
  {
    title: '一级审核',
    children: [
      {
        title: '已完成',
        dataIndex: 'first_finish'
      },
      {
        title: '未完成',
        dataIndex: 'first_process'
      }
    ]
  },
  {
    title: '二级审核',
    children: [
      {
        title: '已完成',
        dataIndex: 'second_finish'
      },
      {
        title: '未完成',
        dataIndex: 'second_process'
      }
    ]
  },
  {
    title: '一审复审',
    children: [
      {
        title: '已完成',
        dataIndex: 'first_re_finish'
      },
      {
        title: '未完成',
        dataIndex: 'first_re_process'
      }
    ]
  },
  {
    title: '二审复审',
    children: [
      {
        title: '已完成',
        dataIndex: 'second_re_finish'
      },
      {
        title: '未完成',
        dataIndex: 'second_re_process'
      }
    ]
  }
]

// 任务总览 / 资源审核时效
export const timeColumns: column[] = [
  {
    title: '剩余时效',
    dataIndex: 'time_remaining'
  },
  {
    title: '图片',
    dataIndex: 'picture_count'
  },
  {
    title: '文本',
    dataIndex: 'text_count'
  },
  {
    title: '视频',
    dataIndex: 'video_count'
  },
  {
    title: '音频',
    dataIndex: 'audio_count'
  },
  {
    title: '综合',
    dataIndex: 'other_count'
  }
]

// 任务查询 / 未分配资源
export const sourceColumns: column[] = [
  {
    title: '审核 ID',
    dataIndex: 'relate_id'
  },
  {
    title: '资源 ID',
    dataIndex: 'resource_id'
  },
  {
    title: '资源来源',
    dataIndex: 'business_type'
  },
  {
    title: '学科',
    dataIndex: 'subject_id'
  },
  {
    title: '分类',
    dataIndex: 'category_name'
  },
  {
    title: '入库时间',
    dataIndex: 'created_at'
  },
  {
    title: '标签',
    dataIndex: 'tag'
  },
  {
    title: '状态',
    dataIndex: 'status'
  }
]
// 任务查询 / 已删除资源
export const sourceDeletedColumns: column[] = [
  {
    title: '审核 ID',
    dataIndex: 'relate_id'
  },
  {
    title: '资源 ID',
    dataIndex: 'resource_id'
  },
  {
    title: '资源来源',
    dataIndex: 'business_type'
  },
  {
    title: '学科',
    dataIndex: 'subject_id'
  },
  {
    title: '分类',
    dataIndex: 'category_name'
  },
  {
    title: '入库时间',
    dataIndex: 'created_at'
  },
  {
    title: '删除时间',
    dataIndex: 'deleted_at'
  },
  {
    title: '状态',
    dataIndex: 'status'
  },
  {
    title: '删除原因',
    dataIndex: 'deleted_reason'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
]

// 任务查询 / 处理中任务（父任务）
export const taskInProcessColumns: column[] = [
  {
    title: '任务 ID',
    dataIndex: 'task_id',
    scopedSlots: { customRender: 'task_id' }
  },
  {
    title: '任务名称',
    dataIndex: 'task_name'
  },
  {
    title: '资源来源',
    dataIndex: 'business_type'
  },
  {
    title: '学科',
    dataIndex: 'subject_id'
  },
  {
    title: '分类',
    dataIndex: 'category_name'
  },
  {
    title: '任务分配时间',
    dataIndex: 'created_at'
  },
  {
    title: '审核类型',
    dataIndex: 'type'
  },
  {
    title: '已完成资源数/资源总数',
    dataIndex: 'resource_info'
  },
  {
    title: '审核人',
    dataIndex: 'user_name',
    scopedSlots: { customRender: 'user_name' }
  }
]

// 任务查询 / 处理中任务（子任务）
export const subTaskInProcessColumns: column[] = [
  {
    title: '审核 ID',
    dataIndex: 'relate_id',
    width: 100
  },
  {
    title: '资源 ID',
    dataIndex: 'resource_id',
    width: 100
  },
  {
    title: '资源 URL',
    dataIndex: 'resource_url',
    scopedSlots: { customRender: 'resource_url' },
    width: 200
  },
  {
    title: '样本类型',
    dataIndex: 'sample_type'
  },
  {
    title: '违规类型',
    dataIndex: 'sensitive_type'
  },
  {
    title: '审核时间',
    dataIndex: 'finish_at'
  },
  {
    title: '标签',
    dataIndex: 'tag',
    width: 50
  },
  {
    title: '审核剩余时效',
    dataIndex: 'deadline'
  },
  {
    title: '审核类型',
    dataIndex: 'type'
  },
  {
    title: '审核状态',
    dataIndex: 'status'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: 180,
    scopedSlots: { customRender: 'operation' }
  }
]

// 任务查询 / 处理中任务（子任务）家长大学评论
export const subTaskInProcessColumns_JZDX: column[] = [
  {
    title: '审核 ID',
    dataIndex: 'relate_id'
  },
  {
    title: '资源 ID',
    dataIndex: 'resource_id'
  },
  {
    title: '评论内容',
    dataIndex: 'comment_content'
  },
  {
    title: '违规类型',
    dataIndex: 'sensitive_type'
  },
  {
    title: '审核时间',
    dataIndex: 'finish_at'
  },
  {
    title: '标签',
    dataIndex: 'tag'
  },
  {
    title: '审核剩余时效',
    dataIndex: 'deadline'
  },
  {
    title: '审核类型',
    dataIndex: 'type'
  },
  {
    title: '审核状态',
    dataIndex: 'status'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: 180,
    scopedSlots: { customRender: 'operation' }
  }
]

// 任务查询 / 已完成任务（父任务）
export const taskCompletedColumns: column[] = [
  {
    title: '任务 ID',
    dataIndex: 'task_id',
    scopedSlots: { customRender: 'task_id' }
  },
  {
    title: '任务名称',
    dataIndex: 'task_name'
  },
  {
    title: '资源来源',
    dataIndex: 'business_type'
  },
  {
    title: '学科',
    dataIndex: 'subject_id'
  },
  {
    title: '分类',
    dataIndex: 'category_name'
  },
  {
    title: '任务分配时间',
    dataIndex: 'created_at'
  },
  {
    title: '审核完成时间',
    dataIndex: 'finish_at'
  },
  {
    title: '审核类型',
    dataIndex: 'process_name'
  },
  {
    title: '审核人',
    dataIndex: 'user_name',
    width: 150,
    scopedSlots: { customRender: 'user_name' }
  }
]

// 任务查询 / 已完成任务（子任务）
export const subTaskCompletedColumns: column[] = [
  {
    title: '审核 ID',
    dataIndex: 'relate_id',
    width: 100
  },
  {
    title: '资源 ID',
    dataIndex: 'resource_id'
  },
  {
    title: '资源 URL',
    dataIndex: 'resource_url',
    scopedSlots: { customRender: 'resource_url' },
    width: 200
  },
  {
    title: '样本类型',
    dataIndex: 'sample_type'
  },
  {
    title: '违规类型',
    dataIndex: 'sensitive_type'
  },
  {
    title: '审核时间',
    dataIndex: 'finish_at'
  },
  {
    title: '标签',
    dataIndex: 'tag'
  },
  {
    title: '审核类型',
    dataIndex: 'type'
  },
  {
    title: '审核状态',
    dataIndex: 'status'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
]

// 任务查询 / 已完成任务（子任务）家长大学评论
export const subTaskCompletedColumns_JZDX: column[] = [
  {
    title: '审核 ID',
    dataIndex: 'relate_id'
  },
  {
    title: '资源 ID',
    dataIndex: 'resource_id'
  },
  {
    title: '评论内容',
    dataIndex: 'comment_content'
  },
  {
    title: '违规类型',
    dataIndex: 'sensitive_type'
  },
  {
    title: '审核时间',
    dataIndex: 'finish_at'
  },
  {
    title: '标签',
    dataIndex: 'tag'
  },
  {
    title: '审核类型',
    dataIndex: 'type'
  },
  {
    title: '审核状态',
    dataIndex: 'status'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
]

// 工作量统计
export const statColumns: column[] = [
  {
    title: '用户名',
    dataIndex: 'username'
  },
  {
    title: '姓名',
    dataIndex: 'realname'
  },
  {
    title: '审核任务总数',
    dataIndex: 'audit_task_num'
  },
  {
    title: '任务延期次数',
    dataIndex: 'delay_task_num'
  },
  {
    title: '审核资源总数',
    dataIndex: 'audit_resource_num'
  },
  {
    title: '通过的资源数',
    dataIndex: 'passed_resource_num'
  },
  {
    title: '驳回的资源数',
    dataIndex: 'return_resource_num'
  },
  {
    title: '升级的资源数',
    dataIndex: 'upgrade_resource_num'
  },
  {
    title: '拒绝资源数',
    dataIndex: 'reject_resource_num'
  },
  {
    title: '当前任务未完成资源数',
    dataIndex: 'undone_resource_num'
  },
  {
    title: '当前任务完成率',
    dataIndex: 'completion_rate'
  },
  {
    title: '当前任务剩余最短时效',
    dataIndex: 'min_remaining_time'
  }
]
